/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchResultsPageSchemaExternalPhase = typeof SearchResultsPageSchemaExternalPhase[keyof typeof SearchResultsPageSchemaExternalPhase];


export const SearchResultsPageSchemaExternalPhase = {
  searching: 'searching',
  ranking: 'ranking',
  ready: 'ready',
  failed: 'failed',
  cancelled: 'cancelled',
  none: 'none',
} as const;
